import styled from "@emotion/styled";
import {TextField} from "@mui/material";

export const StyledInput = styled(TextField)({
	width: "100%",
	background: "#FFFFFF",
	borderRadius: "20px",
	marginBottom: "12px",

	input: {
		padding: "11px 12px",
		borderRadius: "20px !important",
	},

	fieldset: {
		borderColor: "#FFFFFF",
		borderRadius: "20px",
	},
});
